import React, {useEffect} from "react"
import {Carrousel} from "./Carrousel";
import Navigation from "./Navigation";
import "./Styles/topSection.css";

export const TopSection = ({
                               showCatego,
                               changeShowCateState = null,
                               categories,
                               subCategories,
                               leftAd,
                               rightAd,
                               firstMiniAd,
                               secondMiniAd,
                               carouselAds
                           }) => {

    useEffect(() => {
        /*
        const myObserver = new ResizeObserver(el => {
            console.log(el);
            console.log(el.target);
            if(el.target !== undefined) {
                if (el.target.clientHeight > 400) {
                    el.target.style.overflowY = "scroll"
                } else {
                    el.target.style.overflowY = "hidden"
                }
            }
            else
            {
                if (el[0].contentRect.height > 400) {
                    el[0].target.style.overflowY = "scroll"
                } else {
                    el[0].target.style.overflowY = "hidden"
                }
            }
        })

        myObserver.observe(document.querySelector('#navContainer'));
         */
    })

    return (
        <section className="flexcenter top-section">
            <div className="pub-img">
                <img src={process.env.REACT_APP_ADS_BASE_URL + leftAd} alt="pub"/>
            </div>
            <div className="content">

                <div id="navContainer" style={window.innerWidth > 770 ? {
                    opacity: 1,
                    display: "block",
                    zIndex: 1
                } : showCatego ? {opacity: 1, zIndex: 4} : {opacity: 0, zIndex: -1, pointerEvents: "none"}}
                     className="navigation-container">
                    <button style={window.innerWidth > 770 ? {display: "none"} : {display: "block"}}
                            className="closeMenu-btn" onClick={changeShowCateState}>
                        Fermer le menu
                    </button>
                    <div className="navigation-container-background"></div>
                    <Navigation categories={categories} subCategories={subCategories}/>
                </div>

                <div className="carrousel-container">
                    <Carrousel carouselAds={carouselAds}/>
                    <div className="spot-pub2">
                        <div><img src={process.env.REACT_APP_ADS_BASE_URL + firstMiniAd} alt="miniad1"/></div>
                        <div><img src={process.env.REACT_APP_ADS_BASE_URL + secondMiniAd} alt="miniad2"/></div>
                    </div>
                </div>
            </div>
            <div className="pub-img">
                <img src={process.env.REACT_APP_ADS_BASE_URL + rightAd} alt="pub"/>
            </div>

        </section>

    )
}